import { render, staticRenderFns } from "./ApprovalPA.vue?vue&type=template&id=0b5163af"
import script from "./ApprovalPA.vue?vue&type=script&lang=js"
export * from "./ApprovalPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports